module.exports = __webpack_public_path__ + "static/c2-2bce7c56a7173ddbe07cd1a95ec106e3.jpg";